import { Outlet } from "react-router-dom";
const Environment = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default Environment;
